import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./footer.css";
function FooterNuJobs (props)  {

  return (
    <div className="footer-wrapper">

      <div className="footer-content">

        <div className="footer-section">
          <div className="footer-title">NuJobs</div>

          <div className="footer-description">
            Find your next job opportunity with NuJobs.
          </div>
        </div>

        <div className="footer-section">
          <div className="footer-title">Company</div>

          <Link to="/aboutus">About Us</Link>
          <Link to="/nujobscontact">Contact Us</Link>
        </div>

        <div className="footer-section">
          <div className="footer-title">Legal</div>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-conditions">Terms & Conditions</Link>
          <Link to="/cookie-policy">Cookie Policy</Link>
          <Link to="/disclaimer">Disclaimer</Link>
        </div>

        <div className="footer-section">
          <div className="footer-title">Job Seekers</div>

          <Link to="/nujobsotpprocess">Candidate Sign In</Link>
        </div>
        <div className="footer-section">
          <div className="footer-title">Employers</div>

        <Link
          to="/otpprocess"
          state={{
            reason: "start",
            trigger: "signin",
          }}
          className="job-button"
        >
          Employer Sign In
        </Link>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-menu">
          © 2026–2027 HMW Communications Private Limited
        </div>

        <div>
          NuJobs
        </div>
      </div>

    </div>
  );
};

export default FooterNuJobs;
